import { OnboardingCondition } from '../types/public_api';

export const COMMON_NOT_WHEN_CONDITIONS = [
	OnboardingCondition.SIDE_MENU_OPENED,
	OnboardingCondition.YOUTUBE_VIDEO,
	OnboardingCondition.GENERIC_MENU_FULLY_OPENED,
	OnboardingCondition.POPUP_OPENED,
	OnboardingCondition.EDITING_NOTE,
	OnboardingCondition.ADVANCED_SEARCH_VISIBLE,
	OnboardingCondition.NEW_RELEASE_INFO,
	OnboardingCondition.FULL_PAGE_OPENED,
];
